import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const badgeIconStyles = {
  margin: '0 6px 4px -2px',
  width: '16px'
};

const CleaningBadge = () => (
  <div className="cleaning-badge inline-block">
    <img className="inline-block"
      style={badgeIconStyles}
      src="https://assets.peerspace.com/enhanced-badge.svg?v=rb"
      alt="blue shield icon"
    />
    <span>
      <FormattedMessage
        id="shared_components.cleaning_badge.text"
        defaultMessage="Enhanced COVID-19 Measures"
      />
    </span>
  </div>
);

export default CleaningBadge;
